module.exports = __webpack_public_path__ + "img/glasgow-council.84763ab3.png";